<template>
  <div class="complex">
    <div class="item" v-for="(item, index) in newQuestion" :key="index">
      <div class="item-header">
        {{ item.kind | qusType }}：
        <p>
          <span>{{ item.score }}分</span>
        </p>
      </div>
      <div class="item-part h-supplement" v-if="item.kind == '1'" :class="{ noexpand: !item.expand }">
        <supplement
          :des="item.question.qus_descrition"
          :originalValue="item.question.originalCode"
          :showAction="!isReview"
          :answer.sync="
            isReview
              ? item.reviewType === 1
                ? newSimulationQuesAnswer.answer[index]
                  ? newSimulationQuesAnswer.answer[index].answer
                  : ''
                : newSimulationQuesAnswer.right_answer[index]
                ? newSimulationQuesAnswer.right_answer[index].answer
                : ''
              : answer[index].answer
          "
          :key="index"
          :reviewType.sync="item.reviewType"
        />
      </div>
      <div class="item-part" v-if="item.kind == '6'" :class="{ noexpand: !item.expand }">
        <singleChoice
          :question="item.question"
          :answer.sync="
            isReview
              ? item.reviewType === 1
                ? newSimulationQuesAnswer.answer[index]
                  ? newSimulationQuesAnswer.answer[index].answer
                  : ''
                : newSimulationQuesAnswer.right_answer[index]
                ? newSimulationQuesAnswer.right_answer[index].answer
                : ''
              : answer[index].answer
          "
          :key="index"
          :reviewType.sync="item.reviewType"
        />
      </div>
      <div class="item-part" v-if="item.kind == '7'" :class="{ noexpand: !item.expand }">
        <multipleChoice
          :question="item.question"
          :answer.sync="
            isReview
              ? item.reviewType === 1
                ? newSimulationQuesAnswer.answer[index]
                  ? newSimulationQuesAnswer.answer[index].answer
                  : ''
                : newSimulationQuesAnswer.right_answer[index]
                ? newSimulationQuesAnswer.right_answer[index].answer
                : ''
              : answer[index].answer
          "
          :key="index"
          :reviewType.sync="item.reviewType"
        />
      </div>
      <div class="item-part" v-if="item.kind == '9'" :class="{ noexpand: !item.expand }">
        <codeFill
          :des="item.question.descriptions"
          :answer.sync="
            isReview
              ? item.reviewType === 1
                ? newSimulationQuesAnswer.answer[index]
                  ? newSimulationQuesAnswer.answer[index].answer
                  : ''
                : newSimulationQuesAnswer.right_answer[index]
                ? newSimulationQuesAnswer.right_answer[index].answer
                : ''
              : answer[index].answer
          "
          @change="changeCodeFill"
          :options="item.question.options"
          :key="index + 999"
          :reviewType.sync="item.reviewType"
          :index_="index"
        />
      </div>
      <div class="item-expand" @click="handleExpand(index)">
        <Img src="/expand.png" :class="{ noexpandBtn: !item.expand }" />
      </div>
    </div>
  </div>
</template>
<script>
import supplement from './supplement'
import codeFill from './codeFill'
import singleChoice from './singleChoice'
import multipleChoice from './multipleChoice'
export default {
  components: {
    supplement,
    codeFill,
    singleChoice,
    multipleChoice
  },
  props: {
    question: {
      type: Object
    },
    answer: {
      type: Array,
      default: () => []
    },
    simulationQuesAnswer: {
      type: Object,
      default: () => {}
    },
    isReview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newQuestion: [] // 题目
    }
  },
  computed: {
    // 回答的答案
    newAnswer: {
      get() {
        let arr = []
        if (this.answer) {
          arr = JSON.parse(this.answer)
        } else {
          arr = this.newQuestion.map(item => {
            return {
              kind: item.kind,
              answer: ''
            }
          })
        }
        return arr
      },
      set(val) {
        this.$emit('update:answer', JSON.stringify(val))
      }
    },
    // 格式化答案
    newSimulationQuesAnswer() {
      let answer = this.simulationQuesAnswer.answer
      // 格式化答案
      if (answer) {
        answer = JSON.parse(this.simulationQuesAnswer.answer)
      } else {
        // 如果答案不存在，就把程序补充题的答案用默认代码替换
        answer = this.question.qusList.map(item => {
          return {
            kind: item.kind,
            answer: item.kind === '1' ? item.question.originalCode : ''
          }
        })
      }
      const obj = {
        answer: answer || [{ answer: '' }],
        right_answer: this.simulationQuesAnswer.right_answer ? JSON.parse(this.simulationQuesAnswer.right_answer) : [{ right_answer: '' }]
      }
      return obj
    }
  },
  filters: {
    // 格式户类型文字
    qusType(kind) {
      let txt = ''
      switch (kind) {
        case '1':
          txt = '程序补充题'
          break
        case '6':
          txt = '单选题'
          break
        case '7':
          txt = '多选题'
          break
        case '9':
          txt = '程序填空题'
          break
      }
      return txt
    }
  },
  methods: {
    // 更新填空题的数据，不能使用sync直接修改，会直接修改到最后一个填空组件的数据
    changeCodeFill(index, answer) {
      this.answer[index].answer
      const updateData = {
        answer
      }
      this.$set(this.answer, index, updateData)
    },
    // 展开/收起
    handleExpand(index) {
      const obj = this.newQuestion[index]
      obj.expand = !obj.expand
      this.$set(this.newQuestion, index, obj)
    }
  },
  watch: {
    // 设置题目
    question: {
      handler(val) {
        this.newQuestion = val.qusList.map(item => {
          return {
            ...item,
            reviewType: 1
          }
        })
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.complex {
  .item {
    margin-bottom: 20px;
    background: #f2f7fb;
    border-radius: 10px;
    &-header {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      font-size: 16px;
      font-weight: bold;
      color: #484848;
      display: flex;
      justify-content: space-between;
      p {
        span {
          display: inline-block;
          font-size: 12px;
          margin-left: 15px;
          height: 22px;
          border-radius: 4px;
          line-height: 22px;
          color: #fff;
          font-weight: bold;
          width: 40px;
          background-color: #00caa3;
          text-align: center;
          box-shadow: 0px 2px 5px 0px #00ca8069;
        }
      }
    }
    &-expand {
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        height: 12px;
      }
    }
    &-part {
      transition: all 0.5s;
      overflow: hidden;
      height: 560px;
      &.h-supplement {
        height: 610px;
      }
    }
    .noexpand {
      height: 0 !important;
      overflow: hidden;
      transition: all 0.5s;
    }
  }
  .noexpandBtn {
    transform: rotate(180deg);
    transition: all 0.5s;
  }
}
</style>
